import React from "react";
import { Divider, Fab, Grid, Hidden } from "@material-ui/core";
import HubspotForm from "react-hubspot-form";
import styles from "./styles";
import logo from "../../assets/images/logo_saludsa_home.svg";
import {
  Facebook,
  Instagram,
  LinkedIn,
  Twitter,
  YouTube
} from "@material-ui/icons";
import { InputSubscription } from "./InputSubscription";
export const Footer = () => {
  const classes = styles();
  return (
    <footer>
      <div className={classes.containerFooter}>
        <div className={classes.sectionContainer}>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <a
                href={`${process.env.REACT_APP_URL_HOST}`}
                className={classes.imageContainer}
              >
                <img
                  className={classes.logoStyles}
                  src={logo}
                  alt="Logo saludsa"
                />
              </a>
              <Hidden smUp>
                <div className={classes.helpTitle}>
                  <p>
                    ¿Necesitas ayuda? Llámanos al <b>6020920</b>
                  </p>
                </div>
              </Hidden>
              <div>
                <div className={classes.titleFooter}>Dirección Matriz</div>
                <div className={classes.subtitleFooter}>
                  República de El Salvador N° 36-84. Quito
                </div>
                <div className={classes.titleFooter}>Sucursal Principal</div>
                <div className={classes.subtitleFooter}>
                  Guayaquil - Av. Carlos Julio Arosemena Km. 3
                </div>
                <div className={classes.titleFooter}>Sucursal Cuenca</div>
                <div className={classes.subtitleFooter}>
                  Cuenca - Av. Remigio Crespo 3-32 y Agustín Cueva
                </div>
              </div>
            </Grid>
            <Hidden smDown>
              <Grid item xs={12} sm={6}>
                <div className={classes.helpTitle}>
                  <p>
                    ¿Necesitas ayuda? Llámanos al <b>6020920</b>
                  </p>
                </div>
                <Grid container>
                  <Grid item sm={6}>
                    <div className={classes.titleFooter}>
                      Asistencia médica <br />
                      <span className={classes.fontWeightNormal}>
                        (DrSalud)
                      </span>
                    </div>
                    <div
                      className={`${classes.subtitleFooter} ${classes.textBold}`}
                    >
                      (02) 6020920 Opción 1<br />
                      (07) 2880913 Opción 1 (Cuenca)
                      <br />
                      <span className={classes.fontWeightNormal}>
                        Atención 24/7
                      </span>
                    </div>

                    <div>
                      <div className={classes.titleFooter}>
                        Oficinas administrativas
                      </div>
                      <div
                        className={`${classes.subtitleFooter} ${classes.textBold}`}
                      >
                        (593) 2500-3040 UIO
                        <br />
                        (593) 4500-3040 GYE
                        <br />
                        <span className={classes.fontWeightNormal}>
                          Lunes a Viernes
                        </span>
                        <br />
                        08:30 a 19:30
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div>
                      <div className={classes.titleFooter}>
                        Servicio al cliente
                      </div>
                      <div
                        className={`${classes.subtitleFooter} ${classes.textBold}`}
                      >
                        (02) 6020920 Opción 1<br />
                        <span className={classes.fontWeightNormal}>
                          Lunes a Viernes
                        </span>
                        <br />
                        08:30 a 19:30
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Hidden>
          </Grid>
        </div>
        <Hidden smDown>
          <Divider className={classes.dividerStyle} />
          <div className={classes.sectionContainer}>
            <Grid container>
              <Grid item xs={12} sm={3}>
                <div className={classes.titleFooter}>Planes</div>
                <div className="et_pb_text_inner">
                  <ul className={classes.listFooter}>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/cobertura-nacional`}
                      >
                        Cobertura en Ecuador
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href="https://www.experience.ec/"
                      >
                        Cobertura médica mundial
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/oncocare`}
                      >
                        Cobertura médica frente al cáncer
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/`}
                      >
                        Cobertura dental
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/mas-servicios`}
                      >
                        Servicios adicionales
                      </a>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item sm={3}>
                <div className={classes.titleFooter}>Beneficios</div>
                <div className="et_pb_text_inner">
                  <ul className={classes.listFooter}>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/vitality/`}
                      >
                        Vitality
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/drsalud-2/`}
                      >
                        DrSalud
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/consulta_medica_en_linea`}
                      >
                        Consulta médica en línea
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/cero-tramites-2`}
                      >
                        Cero trámites
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/reembolso-online`}
                      >
                        Reembolso online
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/palcare`}
                      >
                        PalCare
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/segunda-opinion-medica`}
                      >
                        Segunda opinión médica
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/cun`}
                      >
                        Clínica Universidad de Navarra
                      </a>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item sm={3}>
                <div className={classes.titleFooter}>Favoritos</div>
                <div className="et_pb_text_inner">
                  <ul className={classes.listFooter}>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/formularios_en_linea`}
                      >
                        Formualrios en línea
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/oda/`}
                      >
                        ODA
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}`}
                      >
                        Certificados
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}`}
                      >
                        Centro de Ayuda DrSalud
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/apps_saludsa`}
                      >
                        App Saludsa
                      </a>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item sm={3}>
                <div className={classes.titleFooter}>Nuestra empresa</div>
                <div className="et_pb_text_inner">
                  <ul className={classes.listFooter}>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/quienes-somos`}
                      >
                        Quienes somos
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}/atencion_accionista`}
                      >
                        Atención al accionista
                      </a>
                    </li>
                    <li>
                      <a
                        className={classes.subtitleListFooter}
                        href={`${process.env.REACT_APP_URL_HOST}`}
                      >
                        Trabaja con nosotros
                      </a>
                    </li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </div>
          <Divider className={classes.dividerStyle} />
        </Hidden>
        <div
          className={`${classes.sectionContainer} ${classes.paddingBottomBack}`}
        >
          <Grid container className={classes.subscribeContainer}>
            <Grid item xs={12} md={3}>
              <div className={classes.titleFooter}>
                Suscríbete a nuestro blog
              </div>
            </Grid>
            <Grid item xs={12} md={6} className={classes.hubspotInput}>
              <HubspotForm
                portalId="3395898"
                formId="d1db11fe-b99c-4259-8594-29564c4b6a38"
                onSubmit={() => console.log("Submit!")}
                onReady={form => console.log("Form ready!")}
                loading={<div>Loading...</div>}
              />
            </Grid>
            <Grid item xs={12} md={3} className={classes.emailSuscribe}>
              <div
                className={`${classes.subtitleListFooter} ${classes.marginSubtitle}`}
              >
                También puedes escribirnos a
              </div>
              <div className={classes.titleFooter}>vive@saludsa.com.ec</div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className={classes.containerFooterBack}>
        <Grid container className={classes.sectionContainerBack}>
          <Grid item xs={12} sm={3}>
            <div className={classes.titleBack}>
              © Salud S.A. Todos los derechos reservados.
            </div>
          </Grid>
          <Grid item xs={12} sm={3} className={classes.displayItemBack}>
            <a
              href="https://www.saludsa.com/wp-content/uploads/2016/06/Poli%CC%81tica-de-privacidad-Saludsa.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkFooterBlue}
            >
              <div className={classes.subtitleBack}>Política de privacidad</div>
            </a>
          </Grid>
          <Grid item xs={12} sm={3} className={classes.displayItemBack}>
            <a href="/mapa-del-sitio/" className={classes.linkFooterBlue}>
              <div className={classes.subtitleBack}>Mapa del sitio</div>
            </a>
          </Grid>
          <Grid item xs={12} sm={3} className={classes.displaySocial}>
            <Fab
              aria-label="Facebook"
              className={classes.socialNetwork}
              href="https://www.facebook.com/Saludsa/"
            >
              <Facebook />
            </Fab>
            <Fab
              aria-label="Instagram"
              className={classes.socialNetwork}
              href="https://www.instagram.com/accounts/login/"
            >
              <Instagram />
            </Fab>
            <Fab
              aria-label="Youtube"
              className={classes.socialNetwork}
              href="https://www.youtube.com/user/SaludSA"
            >
              <YouTube />
            </Fab>
            <Fab
              aria-label="Twitter"
              className={classes.socialNetwork}
              href="https://twitter.com/Esaludsa"
            >
              <Twitter />
            </Fab>
            <Fab
              aria-label="Linkedin"
              className={classes.socialNetwork}
              href="https://www.linkedin.com/company/e-saludsa"
            >
              <LinkedIn />
            </Fab>
          </Grid>
        </Grid>
      </div>
    </footer>
  );
};
